
export class SharePointSiteReportProfile {
  id: string;
  title: string;
  webId: string;
  url: string;
}
